import http from '../../integration/HttpService';
const apiUrl = require('../../config').get(process.env.REACT_APP_ENV).apiUrl;
const apiBase = apiUrl + '/reports/timesheetReport/'

/**
 * getTimesheetComplianceData - get timesheet compliance data
 * @returns {Object}  Object of timesheet data
 */
export function getTimesheetComplianceData(params){
    const endPoint = apiBase + 'getTimesheetComplianceData';
    return http.post(endPoint, params);
}
